import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';

export default ($fetch: $Fetch) => {
  const { $domain } = useNuxtApp();
  const getSearchResults = async (query: string | undefined, page: number, filters: any) => {
    const response = await $fetch<BFFResponse<unknown>>('/search', { body: {
      query, filters, page,
    }, method: 'POST' });

    if (response.data?.redirect) {
      let url = response.data?.redirect;
      if (url.includes($domain.host)) {
        url = url.replace(/^https?:\/\//i, '');
        url = url.replace($domain.host, '');
        await navigateTo(url);
        return null;
      }
      await navigateTo(url, { external: true });
      return null;
    }

    return response;
  };

  return {
    getSearchResults,
  };
};
